import React from 'react';
import { Outlet } from 'react-router-dom';
import { ContainerLayout } from '../ContainerLayout';

export default function AuthLayout() {
  return <ContainerLayout>{<Outlet />}</ContainerLayout>;
}
